const doc = [({"ko":({"adminConstantDefaultSortBy":({"lowestPrice":"최저 가격", "recommended":"추천"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;